import React from "react";

function DashboardSkeleton() {
  return (
    <div className="page page-v2">
      <div className="page-header page-header-v2">
        <div>
          <div className="skel" style={{ height: 26, width: 240, marginBottom: 8 }} />
          <div className="skel" style={{ height: 14, width: 320 }} />
        </div>
      </div>
      <div className="stat-grid stat-grid-v2">
        {[0, 1, 2, 3].map((i) => (
          <div className="stat stat-v2" key={i}>
            <div className="skel" style={{ height: 12, width: 120, marginBottom: 14 }} />
            <div className="skel" style={{ height: 28, width: 60 }} />
          </div>
        ))}
      </div>
      <div className="card">
        <div className="card-header"><div className="skel" style={{ height: 14, width: 160 }} /></div>
        <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {[0, 1, 2].map((i) => (
            <div key={i} style={{ borderTop: i > 0 ? "1px solid var(--border-subtle)" : "none", paddingTop: i > 0 ? 14 : 0 }}>
              <div className="skel" style={{ height: 14, width: 180, marginBottom: 8 }} />
              <div className="skel" style={{ height: 16, width: "70%", marginBottom: 6 }} />
              <div className="skel" style={{ height: 12, width: "90%" }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

window.DashboardSkeleton = DashboardSkeleton;
